<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo Consultor na parte cadastro de Status do Menu Consultor  ==================------->




      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>



      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Pergunta</span>
          <vs-input
            class="w-full"
            name="Pergunta"
            id="Pergunta"
            v-model="formCadastro.pergunta"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Pergunta'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Pergunta'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>


      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Resposta</span>
          <vs-textarea
            class="w-full"
            name="Resposta"
            id="Resposta"
            v-model="formCadastro.resposta"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Resposta'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Resposta'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <span>Ordenação</span>
          <vs-input
            class="w-full"
            name="Ordenação"
            id="Ordenação"
            type="number"
            v-model="formCadastro.ordenacao"
            v-validate="{ required: true }"
            :state="
              utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
            "
            :danger="
              !utilsList.validateState(
                this.veeFields,
                this.veeErrors,
                'Ordenação'
              )
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>


      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idFaq == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from "../../../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../../../services";
import BotaoSubmit from "../../../../components/BotaoSubmit";
import utilsList from "../../../../utils/list";
import cpfCnpj from "../../../../services/cpfCnpj";
import dataFunctions from "../../../../utils/dateConversion";
import imageFunctions from "../../../../utils/imageFunctions";
export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    contadorRender: {
      type: Number,
    },
  },
  watch: {
    dados(value) {
      this.preencheForm();
    },
    contadorRender(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      utilsList,
      decoded: utilsList.buscaToken(),
      aguardeCadastro: false,
      languages: lang,
      funcoesValicao: null,
      tiposPagamentos: [],
      files: new FormData(),
      formCadastro: {
        idFaq: null,
        status: true,
        pergunta: null,
        resposta: null,
        ordenacao: null,
      },
    };
  },
  methods: {

    preencheForm() {
      if (this.dados.idFaq) {
        this.formCadastro.idFaq =
          this.dados.idFaq;
        this.formCadastro.pergunta = this.dados.pergunta;
        this.formCadastro.resposta = this.dados.resposta;
        this.formCadastro.ordenacao = this.dados.ordenacao;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;

      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      var action = "Atualizar/" + this.formCadastro.idFaq;
      var metodo = "put";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idFaq) {
        action = "Adicionar";
        metodo = "post";
        msgRetorno = "Banner Adicionado com sucesso";
      }

      var objSend = { ...this.formCadastro };

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service[metodo]("Faq", action, objSend)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success",
              });
              this.$emit("concluido");
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger",
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list`).then((res) => {
        res.data.forEach((element) => {
          if (element.deletedAt == null)
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
        console.log(this.regionais);
      });
    },
    resetForm() {
      this.formCadastro = {
        idFaq: null,
        status: true,
        pergunta: null,
        resposta: null,
        ordenacao: null,
      };
    },
    onReset(evt) {
      this.$emit("cancel");

      this.resetForm();
    },
  },
  mounted() {
    this.preencheForm();
  },
  created() {
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect,
  },
};
</script>
<!------------ END SCRIPT ------------>
<style scoped>
.vs-con-textarea {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}
#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.img .icone {
  font-size: 50px;
  color: #333;
}

.input-group-color {
  display: flex !important;
  gap: 5px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.color-picker {
  max-width: 2.5rem;
  height: 2.375rem;
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-radius: 4px;
}
</style>
